function FollowUpChips({ chips, onSelect }) {
  return (
    <div className="mt-3">
      <p
        className="text-[11px] mb-1.5"
        style={{
          fontSize: '11px',
          fontWeight: 600,
          background:
            'rgba(0,0,0,1)',
          border:
            '1px solid rgba(0,0,0,1)',
          color: '#00afc2',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          width: 'fit-content',
          padding: '2px 10px',
          borderRadius: '4px',
          marginTop: '15px',
          marginBottom: '10px',
        }}
      >
        You might also ask:
      </p>

      <div className="flex flex-wrap gap-1.5">
        {chips.map((chip) => (
          <button
            key={chip}
            className="px-3 py-1 rounded-full text-[12px] transition-colors"
            style={{
              // background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.5)',
              color: '#ffffff',
            }}
            onClick={() => onSelect(chip)}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                'rgba(0,200,212,0.18)';
              e.currentTarget.style.borderColor =
                '#00C8D4';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                'rgba(0,200,212,0.08)';
              e.currentTarget.style.borderColor =
                'rgba(0,200,212,0.30)';
            }}
          >
            {chip}
          </button>
        ))}
      </div>
    </div>
  );
}

export default FollowUpChips;